import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../mock';

export const Testimonials = () => {
  return (
    <section className="py-16 md:py-32 bg-[#111827] relative overflow-hidden">
      <div className="absolute inset-0 pro-grid opacity-30"></div>
      <div className="ambient-glow absolute top-20 right-10 w-96 h-96 bg-green-500" style={{ animationDelay: '3s' }}></div>
      
      <div className="max-w-7xl mx-auto px-4 sm:px-6 md:px-8 relative z-10">
        {/* Header */}
        <div className="text-center mb-12 md:mb-20">
          <div className="inline-block mb-3 md:mb-4">
            <span className="text-green-400 text-[10px] md:text-xs font-semibold uppercase tracking-wider">Customer Stories</span>
          </div>
          <h2 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-4 md:mb-6 px-4">
            Trusted by <span className="text-green-400">Innovators</span>
          </h2>
          <p className="text-base md:text-lg lg:text-xl text-gray-400 max-w-3xl mx-auto px-4">
            Join hundreds of developers building the future
          </p>
        </div>

        {/* Testimonials Grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-8">
          {testimonials.map((testimonial, index) => (
            <div
              key={testimonial.id}
              className="group"
              style={{ animation: 'fadeInUp 0.8s cubic-bezier(0.4, 0, 0.2, 1) forwards', animationDelay: `${index * 150}ms`, opacity: 0 }}
            >
              <div className="glass-card rounded-xl md:rounded-2xl p-6 md:p-8 h-full hover:border-green-500/20 transition-all duration-300">
                <Quote className="text-green-400/20 mb-3 md:mb-4" size={28} />
                
                {/* Stars */}
                <div className="flex gap-1 mb-4 md:mb-6">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} size={14} fill="rgb(34, 197, 94)" className="text-green-500" />
                  ))}
                </div>
                
                {/* Content */}
                <p className="text-gray-300 mb-6 md:mb-8 leading-relaxed text-sm md:text-base">
                  {testimonial.content}
                </p>
                
                {/* Author */}
                <div className="flex items-center gap-3 md:gap-4 pt-4 md:pt-6 border-t border-white/5">
                  <div className="w-10 h-10 md:w-12 md:h-12 bg-gradient-to-br from-green-400 to-emerald-500 rounded-full flex items-center justify-center font-bold text-black text-sm md:text-base">
                    {testimonial.name.charAt(0)}
                  </div>
                  <div>
                    <div className="font-semibold text-white text-xs md:text-sm">{testimonial.name}</div>
                    <div className="text-[10px] md:text-xs text-gray-500">{testimonial.role}</div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};